/**
 * Normalize product image URLs from the API for use in img[src].
 * The API resolves r2: storage keys to absolute serve URLs; clients use them as-is.
 */
export function resolveProductImageUrl(url: string | undefined | null): string {
  return (url ?? '').trim();
}
